import React,{useState} from "react";
import { Collapse,Button } from "antd";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import Classes from "./index.module.css";
const Panel = Collapse.Panel;
const CustomerGridItem = ({
  name,
  id,
  address,
  tel,
  phone,
  cashBalance,
  chequeBalance,
  maxOpeninvoices,
  maxDaysForCheque,
  cashAccountBalance,
  status,
  invoiceCount,
  chequeAccountBalance,
  open=true,
  btn,
  icon="",
  lat="",
  lng=""
}) => {
  const [loading, setLoading] = useState(false);
  const isOpen=open?{defaultActiveKey:[id]}:null;

  function todo (){
    btn.action()

  }
  return (
    <>
        <Collapse className={Classes.CustomerGridItem} {...isOpen} key={id}>
          <Panel className={status?Classes.indebted:Classes.creditor} showArrow={false} header={[lat && lng ?<i class='fa fa-location-crosshairs'/>:<UserOutlined/>,name , "-" , id]} key={id}>
            <span>{address}</span>
            <table>
              <tbody>
                <tr>
                  <td colSpan={2}>تلفن : </td>
                  <td>{tel ? tel : "-"}</td>
                </tr>
                <tr>
                  <td colSpan={2}>تلفن همراه : </td>
                  <td>{phone ? phone : "-"}</td>
                </tr>
                <tr>
                  <td colSpan={2}>اعتبار ریالی : </td>
                  <td>{cashBalance ? cashBalance : 0}</td>
                </tr>
                <tr>
                  <td colSpan={2}>اعتبار چکی : </td>
                  <td>{chequeBalance ? chequeBalance : 0}</td>
                </tr>
                <tr>
                  <td colSpan={2}>حداکثر فاکتور باز : </td>
                  <td>{maxOpeninvoices ? maxOpeninvoices : 0}</td>
                </tr>
                <tr>
                  <td colSpan={2}>حداکثر مدت چک : </td>
                  <td>{maxDaysForCheque ? maxDaysForCheque : 0}</td>
                </tr>
                <tr className={status?Classes.indebted:Classes.creditor}>
                  <td colSpan={2}>مانده حساب : </td>
                  <td>
                    {cashAccountBalance}
                    {status ? <small>بدهکار</small> : <small>بستانکار</small>}(
                    {invoiceCount}فاکتور)
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>مانده چک : </td>
                  <td>{chequeAccountBalance ? chequeAccountBalance : 0}</td>
                </tr>
              </tbody>
            </table>
            {btn &&(<Button type="primary"  className={`${Classes.bttn}`} onClick={todo} loading={loading} >{btn.title}</Button>)}
          </Panel>
        </Collapse>
    </>
  );
}
export default React.memo(CustomerGridItem)